import { useEffect, useState } from 'react';

import { getSnapshot, getValidToken, subscribe } from './tokenStore';

/**
 * Check 1 (proactive): ensures a fresh token exists BEFORE thumbnails render.
 * Returns null while the very first fetch is in flight — render a placeholder then.
 *
 * @returns {import('./tokenStore').ThumbnailToken|null}
 */
export function useThumbnailToken() {
  const [token, setToken] = useState(getSnapshot);

  useEffect(() => {
    const unsubscribe = subscribe(() => setToken(getSnapshot()));
    // the store may have emitted between the initial render and this effect
    setToken(getSnapshot());
    return unsubscribe;
  }, []);

  useEffect(() => {
    // kicks off a (deduped) refresh when missing or stale; store emit re-renders us
    getValidToken().catch(() => {
      /* surfaced via image placeholders; next mount retries */
    });
  }, [token]);

  return token;
}
